import {queryOptions, useQuery, type UseQueryOptions} from '@tanstack/react-query'

import type {GrubhubOrder} from '@/lib/food-grubhub/foodGrubhubModel'
import {getFoodOrder} from '@/lib/food-grubhub/foodGrubhubPaymentService'
import {NO_REFETCH_OPTIONS} from '@/utils/query/constants'

export function getFoodOrderQueryKey(params: {foodOrderId: string}) {
  return ['food-order', params.foodOrderId] as const
}

export function getFoodOrderQueryOptions<TData = GrubhubOrder, TError = Error>(
  params: {
    foodOrderId: string
    signal?: AbortSignal
  },
  options?: Omit<UseQueryOptions<GrubhubOrder, TError, TData>, 'queryKey' | 'queryFn'>,
) {
  return queryOptions({
    queryKey: getFoodOrderQueryKey(params),
    queryFn: async ({signal}) =>
      getFoodOrder({
        foodOrderId: params.foodOrderId,
        signal,
      }),
    ...NO_REFETCH_OPTIONS,
    ...options,
  })
}

export default function useGrubhubGetFoodOrder(foodOrderId: string, signal?: AbortSignal) {
  return useQuery(
    getFoodOrderQueryOptions({
      foodOrderId,
      signal,
    }),
  )
}
